import type { LedgerType } from '@libs/enums';
import {
  CheckboxInFieldBody,
  FieldHead,
  FormField,
  ItemName,
  Locale,
  SelectWithOptionsInFieldBody,
} from '@ps-smart-cp/ppfw-client';
import type { OptionProps } from '@ps-smart-cp/ppfw-client';
import type { CustomFieldLedgerSettingDetail } from '../models';

interface CustomFieldLedgerSettingRowProps {
  ledger: LedgerType;
  displayOrder: number;
  selectBoxOptions: OptionProps[];
  settingDetail: CustomFieldLedgerSettingDetail;
  setSettingDetail: (setting: CustomFieldLedgerSettingDetail) => void;
  errorFields?: string[];
  previousDisabled?: boolean;
}

// TODO: カスタムフィールド設定のstyled-component対応(https://proship-infra.atlassian.net/browse/AFW-326)
function CustomFieldLedgerSettingRow(props: CustomFieldLedgerSettingRowProps) {
  const {
    ledger,
    displayOrder,
    selectBoxOptions,
    settingDetail,
    errorFields,
    setSettingDetail,
    previousDisabled,
  } = props;

  return (
    <div style={{ display: 'contents' }}>
      <div style={{ gridArea: `${displayOrder - -1}/1`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <FieldHead itemName={ItemName.of([Locale.ja, displayOrder.toString()])} />
        </FormField>
      </div>
      <div style={{ gridArea: `${displayOrder - -1}/2`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <SelectWithOptionsInFieldBody
            id={`custom-field-${ledger}-${displayOrder}`}
            obj={settingDetail}
            setObj={setSettingDetail}
            options={selectBoxOptions}
            prop="customField"
            errorFields={errorFields}
            disabled={previousDisabled}
            needEmptyOption
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${displayOrder - -1}/3`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <CheckboxInFieldBody
            id={`custom-field-is-required-${ledger}-${displayOrder}`}
            obj={settingDetail}
            setObj={setSettingDetail}
            prop="isRequired"
            transparentBorder
            labelName=""
            errorFields={errorFields}
            disabled={previousDisabled || settingDetail.customField === ''}
          />
        </FormField>
      </div>
    </div>
  );
}

export { CustomFieldLedgerSettingRow };
export type { CustomFieldLedgerSettingRowProps };
